// extracted by mini-css-extract-plugin
export default {"wrapper":"zB-z","viewport":"AB-z","container":"BB-z","slide":"CB-z"};